import { patch } from '../../utils/http';

export const autoFillProjectTimesheet = ({ accountId, branchId, projectId, shouldWaitForBreaktimes, ...params }) =>
  patch(`/accounts/${accountId}/branches/${branchId}/projects/${projectId}/timesheets`, {
    ...params,
    options: { shouldWaitForBreaktimes }
  });

export const autoFillOSProjectTimesheet = ({ accountId, branchId, projectId, shouldWaitForBreaktimes, ...params }) =>
  patch(`/accounts/${accountId}/branches/${branchId}/projects/${projectId}/timesheets/os`, {
    ...params,
    options: { shouldWaitForBreaktimes }
  });
